import { useNavigate, useSearchParams } from 'react-router-dom';
import FaceVitalsScanner from './FaceVitalsScanner';

export default function FaceVitalsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clinicCode = searchParams.get('clinic') || '';
  const phone = searchParams.get('phone') || '';
  const name = searchParams.get('name') || '';

  return (
    <FaceVitalsScanner
      clinicCode={clinicCode}
      patientPhone={phone}
      patientName={name}
      onClose={() => navigate(-1)}
    />
  );
}
